import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { FFFStorage } from '@fff-web/fff-utilities';
import env from './env';
import { UUID_LOCAL_STORAGE_KEY } from './Optimizely/utils';

const service = 'registration-flows';

const initializeDDLogs = (isCheckoutV2: boolean) => {
  // Stored userId
  const prospectId = FFFStorage.getFromStorage({ key: UUID_LOCAL_STORAGE_KEY, defaultItem: null });
  datadogLogs.init({
    clientToken: env.dataDogId,
    env: env.envLabel,
    service,
  });
  datadogLogs.setGlobalContextProperty('prospectId', prospectId);
  datadogLogs.setGlobalContextProperty('isCheckoutV2', isCheckoutV2);
};

const initializeDDRum = (isCheckoutV2: boolean) => {
  // Stored userId
  const prospectId = FFFStorage.getFromStorage({ key: UUID_LOCAL_STORAGE_KEY, defaultItem: null });
  datadogRum.init({
    applicationId: env.dataDogRumAppId as string,
    clientToken: env.dataDogRumClientToken as string,
    site: 'datadoghq.com',
    service,
    env: env.envLabel,
    beforeSend: (e, context) => {
      e.context = { ...e.context, isCheckoutV2, prospectId };
    },
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
};

export {
  initializeDDLogs,
  initializeDDRum,
};
